<template>
  <div id="app">
    <Header :currentIndex.sync="currentIndex" />
    <keep-alive>
      <router-view
        style="margin-top: 70px; "
        :currentIndex.sync="currentIndex"
      />
    </keep-alive>
    <Footer :currentIndex.sync="currentIndex" />
  </div>
</template>

<script>
  import Header from './components/Header'
  import Footer from './components/Footer'
  export default {
    name: 'App',
    components: { Header, Footer },
    data() {
      return {
        currentIndex: 1,
      }
    },
    created() {
      const browserLang = navigator.language;
      const langCode = browserLang.split('-')[0];
      if (langCode) this.$i18n.locale = langCode
    }
  }
</script>

<style>
  @import url('./assets/css/public.css');
  #app {
  }
</style>
